import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { USER_API_PATH } from "../../../network/config/apiPaths";
import { updateMessage } from "../../../redux/slice/toastSlice";
import { useDispatch } from "react-redux";
import { consoleLog } from "../../../utils/log-utils";
import { axiosApi } from "../../../network/service/config/AaxiosUtil";
import { useState } from "react";
import { isAdmin, isFranchisLogin } from "../../../utils/userRoles";

function PartnersItem(props) {
  const navigate=useNavigate();
  const dispatch=useDispatch();
  const [product, setItem] = useState(props);
  const [itemStatus, setitemStatus] = useState(product.status);
  const customerOrders=()=>{
     navigate("/customerinfo",{state:{id:props.id,name:props.name,phone:props.phone,city:props.city}})
  }
  const onStatusChange = async () => {
    let status = "YES";
    if (props.status == "NO") {
      status = "YES";
    } else {
      status = "NO";
    }

    let requestBody = {
      status: status,
      id: product.id,
    };

    await axiosApi
      .post(API_CONFIG.API_HOST + USER_API_PATH.UPDATE_USER, requestBody, {
        API_HEADERS,
      })
      .then((response) => {
        consoleLog("USER UPODATE", response);
        if (response.status === 200 && response.data.status === true) {
          setItem(product, (product.status = status));
          setitemStatus(status);
        } else {
          dispatch(
            updateMessage({
              display: true,
              message: "Error While updating info",
            })
          );
        }
      });

    // await dispatch(createUpdateAction(requestBody)).then((response) => {
    //   if (response.status == true) {
    //     setItem(product, (product.status = status));
    //     setitemStatus(status);
    //   } else {
    //     dispatch(
    //       updateMessage({
    //         display: true,
    //         message: "Error While updating info",
    //       })
    //     );
    //   }
    // });
  };
 
  return (
    <>
      <tr>
        <td> {props.sno} </td>
        <td onClick={customerOrders}>
          <Link className="anchor-color-change">{product.name}</Link>
        </td>
        {
          isFranchisLogin()? "":<td> {product.phone} </td>
        }
       
        {/* <td> {props.city} </td> */}
        <td> {product.email}</td>
        <td> {product.companyName}</td>
       

        {/* <td className="align-middle">
          <div class="form-check form-switch col-lg-12 d-flex justify-content-center">

            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              onChange={onStatusChange}
              checked={props.status === "ACTIVE" ? true : false}

            />

          </div>
        </td> */}
      </tr>
    </>
  );
}

export default PartnersItem;
